import { render, staticRenderFns } from "./ControllerFormActions.vue?vue&type=template&id=71420a22&"
import script from "./ControllerFormActions.vue?vue&type=script&lang=js&"
export * from "./ControllerFormActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports